<template>
  <div class="spotlight">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Spotlight',
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
